import { render, staticRenderFns } from "./KPICardCommon.vue?vue&type=template&id=168771bc&scoped=true"
import script from "./KPICardCommon.vue?vue&type=script&lang=js"
export * from "./KPICardCommon.vue?vue&type=script&lang=js"
import style0 from "./KPICardCommon.vue?vue&type=style&index=0&id=168771bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168771bc",
  null
  
)

export default component.exports